var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"headImg"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":`http://www.china-tillage.com:8000${_vm.headImg}`,"alt":""}})]),_c('div',{staticClass:"aboutUsList"},[_c('div',{staticClass:"subject"},[_c('div',[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.aboutData)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }